export const ConsultantRelationsLeader = {
    id: 1,
    title: "Consultant Relations Leader",
    subtitle: "Person responsible for cultivating consultant relationships.This person will be the primary contact for consultant requests for meetings, updates on products, etc."
}

export const SalesLeader = {
    id: 2,
    title: "Sales Leader",
    subtitle: "Escalation contact for sales issues.If there are issues with the bid process, contracting or client-specific situations, this contact will be provided to the consultant."
}

export const MarketingLeader = {
    id: 3,
    title: "Marketing Leader",
    subtitle: "Escalation contact for marketing-related items.If we need to identify a new contact when an employee leaves or have a pressing question, this is who will be contacted."
}

export const DemandGenerationLeader = {
    id: 4,
    title: "Demand Generation Leader",
    subtitle: "Person responsible for bringing new leads/opportunities to the team.This person will be the point of contact for employer leads coming directly through Shortlister."
}

export const SalesOperations = {
    id: 5,
    title: "Sales Operations",
    subtitle: "Person responsible for disseminating leads and/or RFP requests to members of the sales team."
}

export const RfiAdministrator = {
    id: 6,
    title: "RFI Administrator",
    subtitle: "Person responsible for keeping consultant RFI’s up-to-date and accurate."
}

export const PrimaryAdmin = {
    id: "primaryAdmin",
    title: null,
    subtitle: "Owner of your account. They can add/remove users and have access to all sections of the platform."
}

